{
  "id": "campaign-149",
  "name": "Neglected Lea",
  "seed": "campaign:149",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    ",,,,,,x,,,,,,,,,,T",
    ",,,h,,,,,,,,,,,,,,",
    ",,,,,,,,,,,,,,T,,,",
    ",T,x,,,,,,,,,,,T,,",
    ",,,,,,,,Y,,,,,,,,,",
    ",,,T,,,,...,,x...,",
    ",,~~,,,.....,..T..",
    ",,~,,,,.....,...h.",
    ",T,,,,,.....x.....",
    ",,,T,,,,...,,T....",
    ",,,,,,,,,,,,,,....",
    ",,,,,,,,,,,,,,,...",
    ",,,,,,,,,Y,...,,,,",
    ",x,,,,,,,,.....,h,",
    ",,,,,,,,,,,,,,T*,*",
    ",,,,,,,,,,,,,,,,*,",
    "..,,,,,,,,,,,,,,x,",
    "S...,,,,h,,,,,#,,,"
  ],
  "critters": [
    {
      "kind": "fox",
      "x": 10,
      "y": 5
    },
    {
      "kind": "fox",
      "x": 13,
      "y": 13
    },
    {
      "kind": "fox",
      "x": 15,
      "y": 9
    },
    {
      "kind": "deer",
      "x": 8,
      "y": 8
    },
    {
      "kind": "deer",
      "x": 8,
      "y": 7
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 4,
      "y": 8
    },
    {
      "kind": "gas",
      "x": 3,
      "y": 14
    },
    {
      "kind": "gas",
      "x": 13,
      "y": 15
    },
    {
      "kind": "gas",
      "x": 15,
      "y": 17
    },
    {
      "kind": "gas",
      "x": 1,
      "y": 7
    },
    {
      "kind": "gas",
      "x": 1,
      "y": 6
    },
    {
      "kind": "gas",
      "x": 13,
      "y": 10
    },
    {
      "kind": "gas",
      "x": 0,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 14,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 14
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 17
    }
  ],
  "moles": {
    "hills": 4,
    "first": 30,
    "every": 20
  },
  "hills": [
    {
      "x": 0,
      "y": 5,
      "w": 3,
      "h": 3
    },
    {
      "x": 15,
      "y": 5,
      "w": 3,
      "h": 3
    }
  ],
  "generatorVersion": 3,
  "level": 149,
  "biome": "meadow",
  "par": {
    "reel": 13607,
    "push": 11444,
    "selfPropelled": 10771,
    "tractor": 8910,
    "zeroTurn": 7725,
    "fairway": 4583
  },
  "goldTime": {
    "reel": 13088,
    "push": 11444,
    "selfPropelled": 10377,
    "tractor": 8549,
    "zeroTurn": 7606,
    "fairway": 4392
  },
  "routeTries": {
    "par": {
      "reel": 8,
      "push": 0,
      "selfPropelled": 0,
      "tractor": 14,
      "zeroTurn": 17,
      "fairway": 5
    },
    "gold": {
      "reel": 42,
      "push": 0,
      "selfPropelled": 29,
      "tractor": 42,
      "zeroTurn": 32,
      "fairway": 36
    }
  }
}
